// extracted by mini-css-extract-plugin
export default {"container":"UseTemplateModal__container___teJja","content":"UseTemplateModal__content___IbZg8","skeleton-loading":"UseTemplateModal__skeleton-loading___e2iMi"};